import dateUtils from '../../assets/es/utils/date'
import urlUtils from '../../assets/es/utils/url'
import commonUtils from '../../assets/es/utils/common'

import globalHeader from './mod/es/global-header'
import globalFooter from './mod/es/global-footer'

//-- 公共类库
//--------------------------------------------------
const utils = {
  dateUtils,
  urlUtils,
  commonUtils
}
window.mwLibs = !window.mwLibs && {}
Object.assign(mwLibs, utils)


globalHeader.init()
globalFooter.init()

$(document).ready(function() {

  //-- 图片懒加载
  //--------------------------------------------------
  commonUtils.lazyloadPicture(280)

  //-- 回到顶部
  //--------------------------------------------------
  commonUtils.goToTop()
});


